import { resolveText } from '../../i18n/resolveText';
import { getHashParams } from '../../dsl/hashParams';
import { confirmEmailChange } from '../../api/profileApi';
import { getSession } from '../../api/authApi';
import { authService } from '../../auth/AuthService';
function errorMessageFor(block, reason) {
    if (reason === 'expired')
        return block.errorExpired;
    if (reason === 'used')
        return block.errorUsed;
    if (reason === 'taken')
        return block.errorTaken;
    return block.errorInvalid;
}
export function renderEmailChangeVerify(block) {
    const section = document.createElement('section');
    section.className = 'auth';
    const message = document.createElement('p');
    message.className = 'auth__desc';
    message.textContent = resolveText(block.verifying);
    section.appendChild(message);
    // Both outcomes end on a link rather than a redirect: unlike auth-verify,
    // confirming an address doesn't sign anyone in, and the visitor may well be
    // in a browser with no session at all (they opened the mail on a phone).
    function showOutcome(className, text, linkLabel, linkHref) {
        section.innerHTML = '';
        const outcome = document.createElement('p');
        outcome.className = className;
        outcome.textContent = text;
        const link = document.createElement('a');
        link.className = 'cta auth__submit';
        link.href = linkHref;
        link.textContent = resolveText(linkLabel);
        section.append(outcome, link);
    }
    function showError(textKey) {
        showOutcome('auth__error', resolveText(textKey), block.backHomeLabel, '#page=home');
    }
    const token = getHashParams().get('token');
    if (!token) {
        showError(block.errorInvalid);
        return section;
    }
    confirmEmailChange(token)
        .then((result) => {
        if (!result.ok) {
            showError(errorMessageFor(block, result.reason));
            return;
        }
        // The session cached at startup still carries the old email, so re-read
        // it — otherwise the profile page would keep showing the previous
        // address until a reload. Only when there is a session to refresh, and
        // never awaited: a failure here must not turn a change that did happen
        // into an error message.
        const isSignedIn = authService.isAuthorized;
        if (isSignedIn) {
            getSession()
                .then((session) => authService.setAuthenticated(session.user ?? null))
                .catch((error) => console.error('Failed to refresh the session after an email change:', error));
        }
        showOutcome('auth__desc', resolveText(block.success, { email: result.email }), isSignedIn ? block.profileLabel : block.backHomeLabel, isSignedIn ? '#page=profile' : '#page=home');
    })
        .catch((error) => {
        console.error('Failed to confirm the email change:', error);
        showError(block.errorInvalid);
    });
    return section;
}
